import { EditingState, TabsCategories } from '@/store/modules/editing/state';
import { ModelTypes } from '@/typings/types/types';
import { SectionType } from '@/typings/enums/enums';
import { GetterTree } from 'vuex';
import { RootState } from '@/store/state';
import { SectionBaseModel } from '@/components/layout/section/SectionBaseModel';

export type Getters<S = EditingState> = {
  navigatorTabCategory(state: S): SectionType | undefined;
  activeModel(state: S): ModelTypes | undefined;
  activeNavigatorId(state: S): number | string | null;
  activeFormUrl(state: S): string;
  contextMenuPosition(state: S): { xPosition: number; yPosition: number };
  isNavigatorActive(state: S): boolean;
  activeTab(state: S): SectionType | undefined;
  selectedContextItem(state: S): ModelTypes | undefined;
  isContextMenuVisible(state: S): boolean;
  sectionWithGame(state: S): SectionBaseModel | null;
  navigatorCategories(state: S): TabsCategories[];
};

export interface NamespacedGetters {
  'editing/navigatorTabCategory': SectionType | undefined;
  'editing/activeModel': ModelTypes | undefined;
  'editing/activeNavigatorId': number | string | null;
  'editing/activeFormUrl': string;
  'editing/contextMenuPosition': { xPosition: number; yPosition: number };
  'editing/isNavigatorActive': boolean;
  'editing/activeTab': SectionType | undefined;
  'editing/selectedContextItem': ModelTypes | undefined;
  'editing/isContextMenuVisible': boolean;
  'editing/sectionWithGame': SectionBaseModel | null;
  'editing/state': EditingState;
}

export const getters: GetterTree<EditingState, RootState> & Getters = {
  navigatorTabCategory: (state) => {
    return state.activeTabCategory;
  },
  activeModel: (state) => {
    return state.activeModel;
  },
  activeNavigatorId: (state) => {
    return state.activeNavigatorId;
  },
  activeFormUrl: (state) => {
    return state.activeFormUrl;
  },
  contextMenuPosition: (state) => {
    return {
      xPosition: state.contextXPosition,
      yPosition: state.contextYPosition
    };
  },
  isNavigatorActive: (state) => {
    return state.isNavigatorActive;
  },
  activeTab: (state) => {
    return state.activeTabCategory;
  },
  selectedContextItem: (state) => {
    return state.selectedContextItem;
  },
  isContextMenuVisible: (state) => {
    return state.isContextMenuVisible;
  },
  sectionWithGame: (state) => {
    return state.sectionWithGame;
  },
  navigatorCategories(state): TabsCategories[] {
    return state.navigatorCategories;
  }
};
